import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import queryString from "query-string";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { map } from "rxjs/operators";
import { parseApiResponseArray2 } from "@helpers/functions";
import { WatchlistAsset } from "@modules/watchlist/domain/entities/watchlist-asset";

export interface WatchlistPaginatedResponse {
	assets: WatchlistAsset[];
	page: number;
	page_size: number;
	total_count: number;
}

@Injectable({
	providedIn: "root"
})
export class WatchlistRemote {
	constructor(private readonly apiCallService: ApicallService) {}

	public getPaginatedResponse$(page: number, pageSize: number = 500): Observable<WatchlistPaginatedResponse> {
		const event = {
			page: page,
			page_size: pageSize
		};
		const params = queryString.stringify(event, {
			arrayFormat: "bracket",
			skipEmptyString: true,
			skipNull: true
		});

		const options = new ApicallOption();
		options.pagination = true;
		options.raw = true;
		options.apiVersion = "v3";

		return this.apiCallService.get("favorite-assets?" + params, options).pipe(
			map((response) => {
				const assets = parseApiResponseArray2<WatchlistAsset>(response.data);
				const meta = response.meta;

				return {
					...meta,
					assets
				};
			})
		);
	}

	public addAsset$(id: string): Observable<unknown> {
		return this.apiCallService.put("favorite-assets/" + id, new ApicallOption(null));
	}

	public removeAsset$(id: string): Observable<unknown> {
		return this.apiCallService.deleteRequest("favorite-assets/" + id, new ApicallOption());
	}

	public moveAsset$(id: string, sortIndex: number): Observable<unknown> {
		return this.apiCallService.patch("favorite-assets/" + id, new ApicallOption(null, { sort: sortIndex }));
	}

	public addMultipleAssets$(assetIds: string[]): Observable<unknown> {
		return this.apiCallService.post(
			"favorite-assets",
			new ApicallOption(null, { assets: assetIds.map((id) => ({ asset_id: id })) })
		);
	}
}
